<template>

    <div class="row hp-authentication-page">
        <div class="hp-bg-black-20 hp-bg-color-dark-90 col-lg-6 col-12 mm-none">
            <div class="row hp-image-row h-100 px-8 px-sm-16 px-md-0 pb-32 pb-sm-0 pt-32 pt-md-0">
                <div class="hp-logo-item m-16 m-sm-32 m-md-64 w-auto px-0 col-12">
                    <!-- <div class="hp-header-logo d-flex align-items-center">
                        <a href="#" class="position-relative">

                            <img class="hp-logo hp-sidebar-visible hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-visible hp-dark-block" src="./img/favicon.png" alt="logo">
                            
                            <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block" src="./img/favicon.png" alt="logo">
                        </a>

                        <a href="#" target="_blank" class="d-flex">
                            <span class="hp-sidebar-hidden hp-caption fw-normal hp-text-color-primary-1">v.1.0</span>
                        </a>
                    </div> -->
                </div>

                <div class="col-12 px-0">
                    <div class="row h-100 w-100 mx-0 align-items-center justify-content-center bg-1" style="background-size: cover; background-repeat: no-repeat; background-position: start;">
                        <div class="hp-bg-item text-center mb-32 mb-md-0 px-0 col-12">
                            <div style="display: flex; justify-content: center; align-items: center; margin-top: 400px;">
                                <img src="../assets/img/logo_big.png" alt="" width="120px">
                                <h1 class="titleH" style="text-align: center; color: #fff; font-size: 90px; margin-top: 50px; margin-left: -25px;">aesnap</h1>
                            </div>
                        </div>

                        <div class="hp-text-item text-center col-xl-9 col-12">
                            <h2 class="hp-text-color-blac-100 hp-text-color-dark-0 mx-16 mx-lg-0 mb-16" style="color: #fff;"> </h2>
                            <p class="h4 mb-0 fw-normal hp-text-color-blac-80 hp-text-color-dark-30" style="color: #fff;"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-6 py-sm-64 py-lg-0">
            <div class="row align-items-center justify-content-center h-100 mx-4 mx-sm-n32">
                <div class="col-12 col-md-9 col-xl-7 col-xxxl-5 px-8 px-sm-0 pt-24 pb-48">

                    <!-- <div style="display: flex; justify-content: center; align-items: center;" class="dd-none">

                        <img src="../assets/img/favicon.png" alt="" style="width: 40px; margin-bottom: 5px;" class="dd-none">

                    </div> -->
                    
                    <h1 class="mb-0 mb-sm-24 mainTitle titleH" style="margin-top: 20px; ">Create Account</h1>
                    <!-- <p class=" text-black-60 subTitle " style=" margin-bottom: 40px; ">Explore a diverse range of content from creators around the world and discover new artists, performers, and storytellers who inspire and captivate you.</p> -->

                    <!-- TABS -->
                    <ul class="nav nav-tabs mb-42 mt-42" id="myTab" role="tablist">

                        <li class="nav-item" role="presentation" style="width: 50%;">
                            <h6 class="nav-link active" id="fan-tab" data-bs-toggle="tab" data-bs-target="#fan" role="tab" aria-controls="fan" aria-selected="true" style="cursor: pointer;"> Fan  </h6>
                        </li>

                        <li class="nav-item" role="presentation" style="width: 50%;">
                            <h6 class="nav-link" id="creator-tab" data-bs-toggle="tab" data-bs-target="#creator" role="tab" aria-controls="creator" aria-selected="false" style="cursor: pointer;"> Creator </h6>
                        </li>

                    </ul>

                    <div class="tab-content" >

                        <!-- FAN -->
                        <div class="tab-pane fade show active" id="fan" role="tabpanel" aria-labelledby="fan-tab" >

                            <form class="mt-16 mt-sm-32 mb-8" @submit.prevent="verifyToken">
                                <div class="mb-16">
                                    <label for="registerUsername" class="form-label">Name</label>
                                    <input type="text" class="form-control" id="registerUsername" style="padding-top: 5px; padding-bottom: 5px;" placeholder="Full name" v-model="fullName" required>
                                </div>

                                <div class="mb-16">
                                    <label for="registerEmail" class="form-label">Email</label>
                                    <input type="email" class="form-control" id="registerEmail" style="padding-top: 5px; padding-bottom: 5px;" placeholder="youremail@example.com" v-model="email" required>
                                </div>

                                <div class="mb-16" style="position: relative;">
                                    <label for="registerPassword" class="form-label" >Password </label>
                                    <input type="text" class="form-control" id="password" style="padding-top: 5px; padding-bottom: 5px;" placeholder="Minimum of 8 characters" v-model="password" required>
                                    <div style="position: absolute; cursor: pointer; top: 45px; right: 20px;">
                                        <i class="hp-text-color-dark-0 iconly-Light-Show" id="showIcon" @click="passwordMethod"></i>
                                        <i class="hp-text-color-dark-0 iconly-Light-Hide" id="hideIcon" @click="passwordMethod"></i>
                                    </div>
                                </div>

                                <div class="mb-16">
                                    <p class=" text-black-60" style="margin-top: 20px; margin-bottom: 20px;">By signing up you agree to our <a href="https://www.baesnap.com/terms" target="_blank" style="color: #9146ff; font-weight: 500;" >Terms of Service</a> and <a href="https://www.baesnap.com/privacy" style="color: #9146ff; font-weight: 500;" target="_blank">Privacy Policy</a>, and confirm that you are at least 18 years old.</p>
                                </div>

                                <div id="turnstile-container"></div>

                                <button type="submit" @click="setReg" class="btn btn-primary w-100" style=" margin-top: 30px; padding-top: 20px; padding-bottom: 20px; font-size: larger;">
                                    Sign Up
                                </button>
                            </form>

                            <div class="col-12 hp-form-info text-center" style="margin-top: 20px;">
                                <p>Already have an account? <router-link :to="{name: 'sign-in'}" class="hp-text-color-dark-primary-2"  ><strong style="color: #9146ff;" >Sign in</strong></router-link></p>
                                
                            </div>

                        </div>

                        <!-- CREATOR -->
                        <div class="tab-pane fade" id="creator" role="tabpanel" aria-labelledby="creator-tab" >

                            <form class="mt-16 mt-sm-32 mb-8" @submit.prevent="verifyToken">
                                <div class="mb-16">
                                    <label for="registerUsername" class="form-label">Name</label>
                                    <input type="text" class="form-control" id="registerUsername" style="padding-top: 5px; padding-bottom: 5px;" placeholder="Full name" v-model="fullName" required>
                                </div>

                                <div class="mb-16">
                                    <label for="registerEmail" class="form-label">Email</label>
                                    <input type="email" class="form-control" id="registerEmail" style="padding-top: 5px; padding-bottom: 5px;" placeholder="youremail@example.com" v-model="email" required>
                                </div>

                                <div class="mb-16" style="position: relative;">
                                    <label for="password2" class="form-label" >Password </label>
                                    <input type="text" class="form-control" id="password2" style="padding-top: 5px; padding-bottom: 5px;" placeholder="Minimum of 8 characters" v-model="password" required>
                                    <div style="position: absolute; cursor: pointer; top: 45px; right: 20px;">
                                        <i class="hp-text-color-dark-0 iconly-Light-Show" id="showIcon2" @click="passwordMethod2"></i>
                                        <i class="hp-text-color-dark-0 iconly-Light-Hide" id="hideIcon2" @click="passwordMethod2"></i>
                                    </div>
                                </div>

                                <div class="mb-16">
                                    <div class="form-check mt-24">
                                        <input type="checkbox" class="form-check-input" id="exampleCheck1" required>
                                        <p class="form-check-label ps-4" for="exampleCheck1" style="font-size: 12px;"> I am willing to create NSFW content </p>
                                    </div>

                                    <div class="form-check mt-12">
                                        <input type="checkbox" class="form-check-input" id="exampleCheck2" required>
                                        <p class="form-check-label ps-4" for="exampleCheck2" style="font-size: 12px;"> I confirm that I am at least 18 years old and legally permitted to access and upload content on Baesnap. I acknowledge that I have read, understood, and agree to abide by all platform rules, community guidelines, and content policies. I understand that failure to follow these rules may result in account suspension or termination. </p>
                                    </div>

                                </div>

                                <div id="turnstile-container2"></div>

                                <button type="submit" @click="setReg2" class="btn btn-primary w-100" style=" margin-top: 30px; padding-top: 20px; padding-bottom: 20px; font-size: larger;">
                                    Sign Up
                                </button>
                            </form>

                            <div class="col-12 hp-form-info text-center" style="margin-top: 20px;">
                                <p>Already have an account? <router-link :to="{name: 'sign-in'}" class="hp-text-color-dark-primary-2"  ><strong style="color: #9146ff;" >Sign in</strong></router-link></p>
                                
                            </div>

                        </div>

                    </div>

                    <div class="mt-48 mt-sm-96 col-12">

                        <div class="dd-none" style="margin-top: 100px;"></div>
                        <div class=" divider mt-18 mb-24" ></div>

                        <div style="display: flex; justify-content: space-evenly; align-items: center; width: 100%;">
                

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/privacy" target="_blank">Privacy</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/terms" target="_blank">Terms</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/complaints" target="_blank">Complaints</a>
                            </p>

                        </div>

                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>



</template>

<style scoped>

    .bg-1{
        background-image: url(../assets/img/frontpage-banner-3.png);
    }

</style>

<script>
    import { doc, setDoc, collection, query, where, getDocs, serverTimestamp, addDoc,deleteDoc, updateDoc } from "firebase/firestore"; 
    import {getAuth, createUserWithEmailAndPassword, AuthErrorCodes} from "firebase/auth"
    import { db } from '@/firebase';
    import { MD5 } from "md5-js-tools";
    import axios from "axios";

    export default {

        data(){
            return{

                loadingText:"",
                errorText: "",
                successText: "",
                fullName: "",
                email: "",
                password: "",
                uplineCode: "",

                country: "",
                city: "",

                widgetId: null,
                widgetId2: null,

                clKey: "0x4AAAAAACnYZRJ3CySr-qqK",
                botToken: "",

            }
        },

        mounted(){

            this.passwordMethod();
            this.passwordMethod2();
            this.getUplineCode();
            this.getLocation();

            this.botCheck();

            sessionStorage.setItem("regType", "fan");

        },

        methods:{

            async test3(){

                //loading
                this.loadingText = "testing...";
                this.$refs.loadingModal.classList.add("bg-active");

                await deleteDoc(doc(db, "UserFollowers", "xxxcurrentuid", "Followers", "111aaassswweeaeeaa11"));

                this.$refs.loadingModal.classList.remove("bg-active");
            },

            async test2(){

                //loading
                this.loadingText = "testing...";
                this.$refs.loadingModal.classList.add("bg-active");

                await setDoc(doc(db, "UserFollowers", "xxxcurrentuid", "Followers", "222aaassswweeaeeaa22"),{})

                

                this.$refs.loadingModal.classList.remove("bg-active");
            },

            async test(){

                //loading
                this.loadingText = "testing...";
                this.$refs.loadingModal.classList.add("bg-active");

                await setDoc(doc(db, "UserFollowers", "xxxcurrentuid", "Followers", "222aaassswweeaeeaa22"), {

                        timeStamp: serverTimestamp()

                })

                const querySnapshot = await getDocs(collection(db, "UserFollowers", "xxxcurrentuid", "Followers"));
                querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, " => ", doc.data());
                });

                this.$refs.loadingModal.classList.remove("bg-active");
            },

            botCheck(){

                if(this.widgetId == null){

                    this.widgetId = turnstile.render("#turnstile-container", {
                        sitekey: this.clKey,
                        theme: "light",
                        size: "flexible",
                        callback: (token) => {
                            console.log("Success:", token);
                            this.botToken = token;
                        },
                    });

                }

                

                if(this.widgetId2 == null){
                    this.widgetId2 = turnstile.render("#turnstile-container2", {
                        sitekey: this.clKey,
                        theme: "light",
                        size: "flexible",
                        callback: (token) => {
                            console.log("Success:", token);
                            this.botToken = token;
                        },
                    });
                }

            },

            textToBin(minput) {

                let input = minput.trim();

                let output = "";
                for (var i = 0; i < input.length; i++) {
                    output += input[i].charCodeAt(0).toString(2) + " ";
                }

                return output;
            },

            binToText(minput) {
                let input = minput.trim();
                return input.split(" ").map(function(elem) {
                    return String.fromCharCode(parseInt(elem, 2));
                }).join("")
            },

            getLocation(){

                axios.get('https://api.geoapify.com/v1/ipinfo?apiKey=e0c63a09eed346dcb6293ddb7479b721')
                .then( response => {

                    this.city = response.data.city.name;
                    this.country = response.data.country.name;

                });

            },

            setReg(){
                sessionStorage.setItem("regType", "fan");
            },

            setReg2(){
                sessionStorage.setItem("regType", "creator");
            },

            getUplineCode(){
                let urlString = String(window.location.href);
                let url = new URL(urlString);
                let ref = url.searchParams.get("ref");
                if(ref == null){
                    return;
                }
                this.uplineCode = String(ref);
            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
            },

            passwordMethod(){

                let passwordInput = document.getElementById("password");
                let showIcon = document.getElementById("showIcon");
                let hideIcon = document.getElementById("hideIcon");

                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    showIcon.style.display = 'none';
                    hideIcon.style.display = 'block';
                } 
                else {
                    passwordInput.type = "password";
                    showIcon.style.display = 'block';
                    hideIcon.style.display = 'none';
                }

            },

            passwordMethod2(){

                let passwordInput = document.getElementById("password2");
                let showIcon = document.getElementById("showIcon2");
                let hideIcon = document.getElementById("hideIcon2");

                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    showIcon.style.display = 'none';
                    hideIcon.style.display = 'block';
                } 
                else {
                    passwordInput.type = "password";
                    showIcon.style.display = 'block';
                    hideIcon.style.display = 'none';
                }

            },

            verifyToken(){

                //loading
                this.loadingText = "Creating account...";
                this.$refs.loadingModal.classList.add("bg-active");

                if(this.botToken == ""){
                    this.errorText = "Please verify that you are not a robot"
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                //Verify token
                axios.post("https://api.baesnap.com/v1/verify-flare", {
                    token: this.botToken,
                    remoteip: ""
                })
                .then((response) => {

                    if (response.data.success) {
                        this.signUp();
                    }
                    else {
                        this.errorText = "Invalid token. Please verify you are not a robot";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        return;
                    }

                })

            },

            async signUp(){
                
                const auth = getAuth();

                //password length
                if(!(this.password.length >= 8)){
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Password must be 8 characters or more";
                    return;
                }

                let passwordHash = MD5.generate(String(this.password));

                //get referral code
                let referralCode = "B"+ String(Math.floor(Math.random()*9000000000) + 1000000000);

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                createUserWithEmailAndPassword(auth, this.email.toLowerCase(), passwordHash)
                .then(async (data) => {

                    //add data to users
                    await setDoc(doc(db, "Users", data.user.uid), {

                        email : this.email.toLowerCase(),
                        name : this.fullName,
                        profilePic : "https://api.dicebear.com/9.x/initials/svg?seed="+this.fullName,
                        userId : data.user.uid,
                        verified : "no",
                        auth: "no",
                        dateJoined: serverTimestamp(),
                        dateJoinedN: secs,
                        balance: 0,
                        phone: "",
                        gender:"",
                        sexuality:"",
                        
                        type: "user",
                        displayId: "bid"+String(Math.floor(Math.random()*90000000) + 10000000),
                        status: "online",
                        fanCount: 0,
                        followingCount: 0,
                        followersCount: 0, 
                        
                        profileBackground: "https://firebasestorage.googleapis.com/v0/b/fanbayz-5f709.appspot.com/o/DefaultImgs%2FdefaultBack2.png?alt=media&token=82b4ea06-3177-4bf8-a231-c7e07c58f57e",
                        
                        bio: "",
                        facebookLink: "",
                        twitterLink: "",
                        instagramLink: "",
                        snapLink: "",
                        bundle1:0,
                        bundle2:0,
                        bundle3:0,
                        activityMonitor: "no",

                        notiCount: 0,
                        msgList: [],

                        emailNoti: true,
                        pushNoti: true,
                        siteNoti: false,

                        subDescription: "Welcome to my world. Subscribe to gain full and unlimited access to all my exclusive content. Select the package that best fits your interests and start enjoying all the incredible perks today!",

                        postCount: 0,
                        mediaCount: 0,

                        psw: passwordHash,

                        dob: "",
                        dobDay: "",
                        dobMonth: "",

                        earnings: 0,
                        tipBalance: 0,
                        subBalance: 0,
                        ppvBalance: 0,

                        profileType: "sub",

                        likes: 0,
                        likesN: 10000000000,
                        fanCountN: 10000000000,

                        refCode: referralCode,
                        totalRefs: 0,
                        refBalance: 0,
                        upline: this.uplineCode,

                        country: this.country,
                        city: this.city,

                        suspend: false,
                        regType: sessionStorage.getItem("regType")

                        

                    })
                    .then(()=>{
                        this.$refs.loadingModal.classList.remove("bg-active");
                        auth.currentUser.displayName = this.fullName;
                        sessionStorage.setItem("fullName", this.fullName);
                        sessionStorage.setItem("email", this.email.toLowerCase());
                        sessionStorage.setItem('upline', String(this.uplineCode));
                        this.$router.push({name: 'verify'});
                    }) 

                })
                .catch((error) => {

                    if (error.message.includes("email-already-in-use")) {
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        this.errorText = "The email address is already in use by another account.";
                        return;
                    }

                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Unknown error...";
                    return;

                    
                })

            }

        }
    
    }
</script>
